import type { PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export const persistConfig: PersistConfig<any> = {
  key: 'root',
  storage,
  whitelist: [],
};
